/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BookRoomRequest } from '../model';
// @ts-ignore
import { CreateManualReserveDto } from '../model';
// @ts-ignore
import { CreateManualReserveResponse } from '../model';
// @ts-ignore
import { EditPersonRequest } from '../model';
// @ts-ignore
import { ManualBookRoomsRequest } from '../model';
// @ts-ignore
import { RegisterRoomPassengersRequest } from '../model';
// @ts-ignore
import { RegisterRoomPassengersRequestV2 } from '../model';
// @ts-ignore
import { ReserveResponse } from '../model';
// @ts-ignore
import { RoomReserveHalfChargeRequest } from '../model';
// @ts-ignore
import { RoomReserveResponse } from '../model';
/**
 * RoomReserveApiApiUpdatePassengersBillCodeNationalCodePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} nationalCode 
 * @param {EditPersonRequest} [editPersonRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostAxiosParamCreator (billCode: string, nationalCode: string, editPersonRequest?: EditPersonRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiUpdatePassengersBillCodeNationalCodePost', 'billCode', billCode)
    // verify required parameter 'nationalCode' is not null or undefined
    assertParamExists('apiUpdatePassengersBillCodeNationalCodePost', 'nationalCode', nationalCode)
    const localVarPath = `/api/update-passengers/{billCode}/{nationalCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"nationalCode"}}`, encodeURIComponent(String(nationalCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editPersonRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveBillCodeBeginPaymentPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveBillCodeBeginPaymentPostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('roomReserveBillCodeBeginPaymentPost', 'billCode', billCode)
    const localVarPath = `/RoomReserve/{billCode}/begin-payment`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveBillCodeFinalizePost - axios parameter creator
 * 
 * @summary finalizes a reserve with the provider by it\'s billcode
 * @param {string} billCode 
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveBillCodeFinalizePostAxiosParamCreator (billCode: string, billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('roomReserveBillCodeFinalizePost', 'billCode', billCode)
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('roomReserveBillCodeFinalizePost', 'billId', billId)
    const localVarPath = `/RoomReserve/{billCode}/finalize`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveBillCodeRegisterPassengersPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [authorization] 
 * @param {string} [xPlayerId] 
 * @param {RegisterRoomPassengersRequest} [registerRoomPassengersRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveBillCodeRegisterPassengersPostAxiosParamCreator (billCode: string, authorization?: string, xPlayerId?: string, registerRoomPassengersRequest?: RegisterRoomPassengersRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('roomReserveBillCodeRegisterPassengersPost', 'billCode', billCode)
    const localVarPath = `/RoomReserve/{billCode}/register-passengers`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerRoomPassengersRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveBillCodeSetReserveHafChargePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {RoomReserveHalfChargeRequest} [roomReserveHalfChargeRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostAxiosParamCreator (billCode: string, roomReserveHalfChargeRequest?: RoomReserveHalfChargeRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('roomReserveBillCodeSetReserveHafChargePost', 'billCode', billCode)
    const localVarPath = `/RoomReserve/{billCode}/SetReserveHafCharge`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(roomReserveHalfChargeRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveBookRoomsPost - axios parameter creator
 * 
 * @param {string} [authorization] 
 * @param {string} [xPlayerId] 
 * @param {BookRoomRequest} [bookRoomRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveBookRoomsPostAxiosParamCreator (authorization?: string, xPlayerId?: string, bookRoomRequest?: BookRoomRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/RoomReserve/BookRooms`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(bookRoomRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveByIdBillIdFinalizePost - axios parameter creator
 * 
 * @summary finalizes a reserve with the provider by it\'s billcode
 * @param {string} billCode 
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveByIdBillIdFinalizePostAxiosParamCreator (billCode: string, billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('roomReserveByIdBillIdFinalizePost', 'billCode', billCode)
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('roomReserveByIdBillIdFinalizePost', 'billId', billId)
    const localVarPath = `/RoomReserve/byId/{billId}/finalize`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveCreateManualReservePost - axios parameter creator
 * 
 * @param {string} [authorization] 
 * @param {string} [xPlayerId] 
 * @param {CreateManualReserveDto} [createManualReserveDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveCreateManualReservePostAxiosParamCreator (authorization?: string, xPlayerId?: string, createManualReserveDto?: CreateManualReserveDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/RoomReserve/CreateManualReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createManualReserveDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveManualBookRoomsPost - axios parameter creator
 * 
 * @param {ManualBookRoomsRequest} [manualBookRoomsRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveManualBookRoomsPostAxiosParamCreator (manualBookRoomsRequest?: ManualBookRoomsRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/RoomReserve/ManualBookRooms`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(manualBookRoomsRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiRoomReserveReserveReserveIdFinalizePost - axios parameter creator
 * 
 * @summary finalizes a reserve with the provider by it\'s billcode
 * @param {number} reserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiRoomReserveReserveReserveIdFinalizePostAxiosParamCreator (reserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('roomReserveReserveReserveIdFinalizePost', 'reserveId', reserveId)
    const localVarPath = `/RoomReserve/reserve/{reserveId}/finalize`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [authorization] 
 * @param {string} [xPlayerId] 
 * @param {RegisterRoomPassengersRequestV2} [registerRoomPassengersRequestV2] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostAxiosParamCreator (billCode: string, authorization?: string, xPlayerId?: string, registerRoomPassengersRequestV2?: RegisterRoomPassengersRequestV2, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('v2RoomReserveBillCodeRegisterPassengersPost', 'billCode', billCode)
    const localVarPath = `/v2/room-reserve/{billCode}/register-passengers`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerRoomPassengersRequestV2, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiUpdatePassengersBillCodeNationalCodePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostRequest
 */
export interface RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiApiUpdatePassengersBillCodeNationalCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiApiUpdatePassengersBillCodeNationalCodePost
     */
    readonly nationalCode: string

    /**
     * 
     * @type {EditPersonRequest}
     * @memberof RoomReserveApiApiUpdatePassengersBillCodeNationalCodePost
     */
    readonly editPersonRequest?: EditPersonRequest
}

/**
 * Request parameters for roomReserveBillCodeBeginPaymentPost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveBillCodeBeginPaymentPostRequest
 */
export interface RoomReserveApiRoomReserveBillCodeBeginPaymentPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeBeginPaymentPost
     */
    readonly billCode: string
}

/**
 * Request parameters for roomReserveBillCodeFinalizePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveBillCodeFinalizePostRequest
 */
export interface RoomReserveApiRoomReserveBillCodeFinalizePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeFinalizePost
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof RoomReserveApiRoomReserveBillCodeFinalizePost
     */
    readonly billId: number
}

/**
 * Request parameters for roomReserveBillCodeRegisterPassengersPost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveBillCodeRegisterPassengersPostRequest
 */
export interface RoomReserveApiRoomReserveBillCodeRegisterPassengersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeRegisterPassengersPost
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeRegisterPassengersPost
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeRegisterPassengersPost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {RegisterRoomPassengersRequest}
     * @memberof RoomReserveApiRoomReserveBillCodeRegisterPassengersPost
     */
    readonly registerRoomPassengersRequest?: RegisterRoomPassengersRequest
}

/**
 * Request parameters for roomReserveBillCodeSetReserveHafChargePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostRequest
 */
export interface RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBillCodeSetReserveHafChargePost
     */
    readonly billCode: string

    /**
     * 
     * @type {RoomReserveHalfChargeRequest}
     * @memberof RoomReserveApiRoomReserveBillCodeSetReserveHafChargePost
     */
    readonly roomReserveHalfChargeRequest?: RoomReserveHalfChargeRequest
}

/**
 * Request parameters for roomReserveBookRoomsPost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveBookRoomsPostRequest
 */
export interface RoomReserveApiRoomReserveBookRoomsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBookRoomsPost
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveBookRoomsPost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {BookRoomRequest}
     * @memberof RoomReserveApiRoomReserveBookRoomsPost
     */
    readonly bookRoomRequest?: BookRoomRequest
}

/**
 * Request parameters for roomReserveByIdBillIdFinalizePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveByIdBillIdFinalizePostRequest
 */
export interface RoomReserveApiRoomReserveByIdBillIdFinalizePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveByIdBillIdFinalizePost
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof RoomReserveApiRoomReserveByIdBillIdFinalizePost
     */
    readonly billId: number
}

/**
 * Request parameters for roomReserveCreateManualReservePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveCreateManualReservePostRequest
 */
export interface RoomReserveApiRoomReserveCreateManualReservePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveCreateManualReservePost
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiRoomReserveCreateManualReservePost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {CreateManualReserveDto}
     * @memberof RoomReserveApiRoomReserveCreateManualReservePost
     */
    readonly createManualReserveDto?: CreateManualReserveDto
}

/**
 * Request parameters for roomReserveManualBookRoomsPost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveManualBookRoomsPostRequest
 */
export interface RoomReserveApiRoomReserveManualBookRoomsPostRequest {
    /**
     * 
     * @type {ManualBookRoomsRequest}
     * @memberof RoomReserveApiRoomReserveManualBookRoomsPost
     */
    readonly manualBookRoomsRequest?: ManualBookRoomsRequest
}

/**
 * Request parameters for roomReserveReserveReserveIdFinalizePost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiRoomReserveReserveReserveIdFinalizePostRequest
 */
export interface RoomReserveApiRoomReserveReserveReserveIdFinalizePostRequest {
    /**
     * 
     * @type {number}
     * @memberof RoomReserveApiRoomReserveReserveReserveIdFinalizePost
     */
    readonly reserveId: number
}

/**
 * Request parameters for v2RoomReserveBillCodeRegisterPassengersPost operation in RoomReserveApi.
 * @export
 * @interface RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostRequest
 */
export interface RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {RegisterRoomPassengersRequestV2}
     * @memberof RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost
     */
    readonly registerRoomPassengersRequestV2?: RegisterRoomPassengersRequestV2
}

/**
* 
* @param {RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiApiUpdatePassengersBillCodeNationalCodePost(requestParameters: RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiApiUpdatePassengersBillCodeNationalCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.nationalCode, requestParameters.editPersonRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveBillCodeBeginPaymentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveBillCodeBeginPaymentPost(requestParameters: RoomReserveApiRoomReserveBillCodeBeginPaymentPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveBillCodeBeginPaymentPostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<ReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary finalizes a reserve with the provider by it\'s billcode
* @param {RoomReserveApiRoomReserveBillCodeFinalizePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveBillCodeFinalizePost(requestParameters: RoomReserveApiRoomReserveBillCodeFinalizePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveBillCodeFinalizePostAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveBillCodeRegisterPassengersPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveBillCodeRegisterPassengersPost(requestParameters: RoomReserveApiRoomReserveBillCodeRegisterPassengersPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveBillCodeRegisterPassengersPostAxiosParamCreator(requestParameters.billCode, requestParameters.authorization, requestParameters.xPlayerId, requestParameters.registerRoomPassengersRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveBillCodeSetReserveHafChargePost(requestParameters: RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveBillCodeSetReserveHafChargePostAxiosParamCreator(requestParameters.billCode, requestParameters.roomReserveHalfChargeRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveBookRoomsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveBookRoomsPost(requestParameters: RoomReserveApiRoomReserveBookRoomsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveBookRoomsPostAxiosParamCreator(requestParameters.authorization, requestParameters.xPlayerId, requestParameters.bookRoomRequest, options, configuration);
    const request: () => AxiosPromise<RoomReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary finalizes a reserve with the provider by it\'s billcode
* @param {RoomReserveApiRoomReserveByIdBillIdFinalizePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveByIdBillIdFinalizePost(requestParameters: RoomReserveApiRoomReserveByIdBillIdFinalizePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveByIdBillIdFinalizePostAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveCreateManualReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveCreateManualReservePost(requestParameters: RoomReserveApiRoomReserveCreateManualReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveCreateManualReservePostAxiosParamCreator(requestParameters.authorization, requestParameters.xPlayerId, requestParameters.createManualReserveDto, options, configuration);
    const request: () => AxiosPromise<CreateManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiRoomReserveManualBookRoomsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveManualBookRoomsPost(requestParameters: RoomReserveApiRoomReserveManualBookRoomsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveManualBookRoomsPostAxiosParamCreator(requestParameters.manualBookRoomsRequest, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary finalizes a reserve with the provider by it\'s billcode
* @param {RoomReserveApiRoomReserveReserveReserveIdFinalizePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiRoomReserveReserveReserveIdFinalizePost(requestParameters: RoomReserveApiRoomReserveReserveReserveIdFinalizePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiRoomReserveReserveReserveIdFinalizePostAxiosParamCreator(requestParameters.reserveId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPost(requestParameters: RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RoomReserveApiV2RoomReserveBillCodeRegisterPassengersPostAxiosParamCreator(requestParameters.billCode, requestParameters.authorization, requestParameters.xPlayerId, requestParameters.registerRoomPassengersRequestV2, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
